export default "__VITE_ASSET__DJU2KoQo__"